import React from "react";
import { BtnSua } from "./Sua/BtnSua";
import { BtnXoa } from "./Xoa/BtnXoa";
import { BtnSuDung } from "./Sudung/BtnSuDung";

export const ContentTable = ({ listDanhSach, CustomCheckbox, onEdit, onDelete, onUse}) => {
    const getLoaiPhiKhacText = (LoaiPhiKhac) => {
        if (LoaiPhiKhac === 1) return "Chỉ nhập tiền";
        if (LoaiPhiKhac === 2) return "Chỉ nhập %";
        if (LoaiPhiKhac === 3) return "Nhập tiền và %";
        return "Không xác định";
    };

    if (!listDanhSach || listDanhSach.length === 0) {
        return (
            <div className="custom-table-row no-data" style={{ minHeight: 56, justifyContent: 'center' }}>
                <p>Không có dữ liệu</p>
            </div>
        );
    }

    return (
        <>
            {listDanhSach.map((item) => (
                <div 
                    key={item.Id} 
                    className="custom-table-row"
                    style={{ minHeight: "56px", borderBottom: '1px solid #e0e0e0' }}
                >
                    <div className="custom-table-cell text-left flex-basis-35 flex-basis-35-sm">
                        <span className="mobile-column-name color7-bold">Tên phí khác</span>
                        <div className="center-wrapper word-break">
                            {item.TenPhiKhac}
                        </div>
                    </div>
                    <div className="custom-table-cell text-left flex-basis-30 flex-basis-30-sm">
                        <span className="mobile-column-name color7-bold">Kiểu nhập liệu</span>
                        <div className="center-wrapper word-break">
                            {getLoaiPhiKhacText(item.LoaiPhiKhac)}
                        </div>
                    </div>
                    <div className="custom-table-cell flex-basis-15 flex-basis-15-sm">
                        <span className="mobile-column-name color7-bold">Sử dụng</span>
                        <div className="center-wrapper word-break text-center" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <BtnSuDung item={item} onUse={onUse} CustomCheckbox={CustomCheckbox} />
                        </div>
                    </div>
                    <div className="custom-table-cell flex-basis-20 flex-basis-20-sm">
                        <span className="mobile-column-name color7-bold">Chức năng</span>
                        <div className="center-wrapper text-center" style={{ display: 'flex', justifyContent: 'center', gap: '8px' }}>
                            {!item.IsUsed ? (
                                <>
                                    <BtnSua item={item} onEdit={onEdit} />
                                    <BtnXoa item={item} onDelete={onDelete} />
                                </>
                            ) : (
                                <span
                                    className="text-muted"
                                    title="Không thể sửa/xóa vì đã được sử dụng"
                                    style={{ cursor: 'not-allowed' }}
                                >
                                    -
                                </span>
                            )}
                        </div>
                    </div>
                </div>
            ))}
        </>
    );
};